module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("kYIpL"))).then(() => parcelRequire('j7llE'));